import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import CoreMap from '@bd/bdui-coremap';
import PageSectionHeading from '../../PageSectionHeading';
import { colors, typography } from '../../../styles';

const styles = css`
  padding: 45px 0 120px;
  text-align: center;
  @media (min-width: 992px) {
    padding: 90px 0;
  }
  .TabMenu {
    margin: 0 0 30px 0;
    @media (min-width: 992px) {
      margin: 0 0 60px 0;
    }
  }
`;

const mapStyles = css`
  width: 100%;
  height: 300px;
  @media (min-width: 768px) {
    width: 100%;
    height: 600px;
  }
  .leaflet-popup {
    transition: none;
    background-color: white;
    bottom: 18px !important;
    left: -100px !important;
  }
  .leaflet-container {
    height: 100%;
    width: 100%;
    z-index: 0;
    a.leaflet-popup-close-button {
      font-size: 15px;
      color: ${colors.brand1};
      background-color: white;
      padding: 4px;
      width: auto;
      height: auto;
    }
  }
  .leaflet-popup-content-wrapper {
    padding: 0;
    border-radius: 0;
    background: none;
  }
  .leaflet-popup-content-wrapper,
  .leaflet-popup-tip {
    box-shadow: 0px 5px 15px 1px rgba(0,0,0,0.40);
  }
  .leaflet-popup-content {
    margin: 0;
    width: 200px !important;
    background-color: ${colors.white};
  }
  .MapMarker_locationPopUp {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 15px;
  }
  .MapMarker_locationTitle {
    line-height: 1.2;
    font-size: 15px;
    margin: 0;
    color: ${colors.brand1Light};
    font-family: ${typography.SansSerif} !important;
    font-weight: 700;
  }
  .leaflet-pane .leaflet-marker-pane img {
    height: 25px !important;
    width: 25px !important;
    margin-left: -12px !important;
    margin-top: -35px !important;
  }
`;


function LocationsMap({ content }) {
  return (
    <div className={styles}>
      {
        get(content, '[0].section_heading') &&
        <PageSectionHeading h3={get(content, '[0].section_heading')} />
      }
      <div>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <CoreMap
                className={mapStyles}
                markers={get(content, '[0].location_list', []).map(ll => get(ll, 'location[0]'))}
                pin={{
                  iconUrl: '/images/icon-map-pin-brand.svg',
                  iconSize: [26, 35],
                  iconAnchor: [13, 35],
                }}
                popup={({ marker: location }) => (
                  <div className="MapMarker_locationPopUp">
                    <h5 className="MapMarker_locationTitle">{location.title}</h5>
                  </div>
                )}
                boundaryPadding={0}
              />
              {
                get(content, '[0].pdf_download[0].pdf_file.contentUrl') &&
                <div className="d-flex justify-content-center my-4">
                  <a href={get(content, '[0].pdf_download[0].pdf_file.contentUrl')} target="_blank" rel="noopener noreferrer" className="btn btn-brand1">{get(content, '[0].pdf_download[0].button_text')}</a>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

LocationsMap.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default LocationsMap;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/LocationsMap.section.js